export const PURE_WHITE = '#fff';
export const PURE_BLACK = '#000';

export const GREY_A = '#808080';
export const GREY_B = '#b3b3b3';
export const GREY_C = '#ccc';
export const GREY_D = '#d8d8d8';
export const GREY_E = '#eee';
export const GREY_F = '#f2f2f2';
export const GREY_G = '#333';
export const GREY_H = '#787878';
export const GREY_I = '#404040';

export const RED_A = '#e3463d';
export const BLUE_A = '#4bbcff';
export const BLUE_B = '#43aae6';
export const BLUE_C = '#009DFF';
export const BLUE_D = '#5ec0ff';
export const ORANGE_A = '#ef871a';

export const YELLOW_A = '#ebc56a';
export const YELLOW_B = '#FFF3AB';
export const YELLOW_C = '#FFE539';
export const YELLOW_D = '#FFF9D5';
